import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import SidebarIcons from "@/Components/Icons/SidebarIcons";
import { toggleMobileDrawer } from "@/reducers/clientcommon";
import useIsMobile from "@/utilities/hooks/useIsMobile";

/**
 * Renders a sidebar link component with the specified href, type, text, and activePage.
 *
 * @param {Object} props - Object containing the href, type, text, and activePage properties
 * @return {JSX.Element} The rendered sidebar link component
 */
const SidebarLink = ({
  to,
  href,
  type,
  text,
  activePage,
  handleClick,
  _className = "",
  isExanded = false,
  cls = "",
}) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const getDisabledClasses = () => {
    let _link = href ? href : to;
    if (_link === "#") {
      return "opacity-30 cursor-not-allowed";
    } else {
      return "hover:bg-grey";
    }
  };

  const onLinkClick = (e) => {
    handleClick?.(e);
    // Auto-close mobile drawer on navigation
    if (isMobile) dispatch(toggleMobileDrawer(false));
  };

  return (
    <Link
      to={href ? href : to}
      className={`transition-linear flex h-[40px] cursor-pointer items-center rounded-lg px-4 py-2 text-[14px] font-semibold !no-underline !duration-200 ${
        activePage === type
          ? "tour-job-rate-clientsidebar bg-primary-100 !text-primary"
          : `text-txtColor ${getDisabledClasses()}`
      } ${cls} ${_className}`}
      onClick={onLinkClick}
    >
      <div
        className={`items transition-linear relative flex w-full justify-start group-hover:gap-4 ${_className}`}
      >
        <SidebarIcons type={activePage === type ? `${type}Active` : type} />
        <span
          className={`transition-linear absolute left-[40px] top-[2px] inline-block ${isExanded ? "w-0" : ""} overflow-hidden whitespace-nowrap break-keep group-hover:w-[calc(100%-48px)]`}
        >
          {text}
        </span>
      </div>
    </Link>
  );
};

export default SidebarLink;
